import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardTitle } from '@patternfly/react-core';
import { Table, Tbody, Tr, Th, Td } from '@patternfly/react-table';
import type { LabDriverComponentProps } from '../types';
import './styles.scss';

type OCPContext = {
  idm_username?: string;
  idm_password?: string;
  api_url?: string;
  console_url?: string;
  cluster_id?: string;
};

const OCPSharedLabComponent: React.FC<LabDriverComponentProps> = ({
  labComponent,
}) => {
  const { t } = useTranslation();
  const context = labComponent.context as OCPContext | undefined;

  if (!context?.idm_username) {
    return null;
  }

  const rows = [
    {
      key: 'username',
      label: t('Username'),
      env: 'RHT_OCP4_DEV_USER',
      value: context.idm_username,
    },
    {
      key: 'password',
      label: t('Password'),
      env: 'RHT_OCP4_DEV_PASSWORD',
      value: context.idm_password,
    },
    {
      key: 'api',
      label: t('API Endpoint'),
      env: 'RHT_OCP4_MASTER_API',
      value: context.api_url ? (
        <a href={context.api_url} rel="noopener noreferrer" target="_blank">
          {context.api_url}
        </a>
      ) : null,
    },
    {
      key: 'console',
      label: t('Console Web Application'),
      env: '',
      value: context.console_url ? (
        <a href={context.console_url} rel="noopener noreferrer" target="_blank">
          {context.console_url}
        </a>
      ) : null,
    },
    {
      key: 'cluster_id',
      label: t('Cluster Id'),
      env: '',
      value: context.cluster_id,
    },
  ];

  return (
    <Card className="ocp-shared-lab-component__card">
      <CardTitle>OpenShift Details</CardTitle>
      <CardBody>
        <Table variant="compact" borders={false}>
          <Tbody>
            {rows.map((row) => (
              <Tr key={row.key}>
                <Th>{row.label}</Th>
                <Th>{row.env}</Th>
                <Td>{row.value}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default observer(OCPSharedLabComponent);
